import React from 'react';
import './footer.css'; 
import { FaInstagram, FaLinkedinIn, FaFacebookF, FaWhatsapp,FaYoutube } from 'react-icons/fa';
import logo from '../../assets/images/footer logo.png';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-logo-section">
                    <img src={logo} alt="Hcura Logo" className="footer-logo" />
                    <p className="footer-description">
                        Hcura Homeopathy Multi-Speciality Hospital, led by expert homeopaths, delivers quality healthcare combining expertise and compassion for all sections of society.
                    </p>
                </div>
                <div className="footer-links">
                    <div className="footer-column">
                        <h4>Enquiry Us</h4>
                        <p><a href="tel:9964688333">+91 9964688333</a></p>
                        <p><a href="tel:8870001377">+91 8870001377</a></p>
                        
                        <h4>Email Us</h4>
                        <p><a href="mailto:care@h-cura.com">care@h-cura.com</a></p>
                        <p><a href="mailto:admin@h-cura.com">admin@h-cura.com</a></p>
                    </div>

                    <div className="footer-column">
                        <h4>Registered Office</h4>
                        <p>H-Cura Homeopathy Multispecialty Clinic,<br/>
                            No:779&780 2nd Floor, Sai Towers Building,<br/>
                            South, E End Main Rd, Bengaluru,<br/>
                            Karnataka 560069, India
                        </p>
                    </div>

                    <div className="footer-column">
                        <h4>Useful Links</h4>
                        <p onClick={() => handleNavigation('/')}>Home</p>
                        <p onClick={() => handleNavigation('/about/')}>About Us</p>
                        <p onClick={() => handleNavigation('/contact-us/')}>Contact Us</p>
                    </div>

                    <div className="footer-column footer-text-align">
                        <h4>Our Clinics</h4>
                        <p><strong className="city-highlight">Bangalore:</strong> <span className="clinic-link" onClick={() => handleNavigation('/homeopathy-clinic-in-bangalore/')}>Jayanagar</span></p>

                        <p><strong className="city-highlight">Chennai:</strong> Valasaravakkam , Gerugambakkam</p>
                        <p className="chennai-indent">Tambaram         , Navalur , Kodambakkam ,</p>
                        <p className="chennai-indent">  Coimbatore ,Salem</p>

                        <p><strong className="city-highlight">Pondicherry:</strong> <span className="clinic-link" >Vallalar Salai Road [near white town]</span></p>
                    <p><strong className="city-highlight">Andhra Pradesh:</strong> <span className="clinic-link" >Guntur</span></p>

                    </div>

                    {/* <div className="footer-column">
                        <h4>Treatments</h4>
                        <p>Skin Diseases</p>
                        <p>Hairfall</p>
                        <p>Diabetes</p>
                        <p>Piles</p>
                        <p>Male Infertility</p>
                    </div> */}
                </div>
                <div className="footer-social">
                    <div className="social-icons">
                        <a href="https://www.instagram.com/hcura_healthcare/" target="_blank" rel="noopener noreferrer">
                            <FaInstagram />
                        </a>
                        <a href="https://www.linkedin.com/company/h-cura.app/" target="_blank" rel="noopener noreferrer">
                            <FaLinkedinIn />
                        </a>
                        <a href="https://www.facebook.com/H.CuraApp" target="_blank" rel="noopener noreferrer">
                            <FaFacebookF />
                        </a>
                        <a href="https://wa.me/+918870001377" target="_blank" rel="noopener noreferrer">
                            <FaWhatsapp />
                        </a>
                        <a href="https://www.youtube.com/channel/UCPHp97GCyIxyN7kRNOGET0A" target="_blank" rel="noopener noreferrer">
                            <FaYoutube />
                        </a>
                    </div>
                    <p><a href="/privacypolicy" onClick={() => handleNavigation('/privacypolicy')}>Privacy Policy</a> 
                      &nbsp;&nbsp;&nbsp;
                        <a href="/disclaimer" onClick={() => handleNavigation('/disclaimer')}>Disclaimer</a>
                          &nbsp;&nbsp;&nbsp;
                        <a href="/terms" onClick={() => handleNavigation('/terms')}>Terms and Conditions</a>
                    </p>
                    <p>&copy; 2024 H-Cura Pvt Ltd. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
